import { arEG, enUS } from "date-fns/locale";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS, provideDateFnsAdapter } from "@angular/material-date-fns-adapter";
import { Component, inject, ViewEncapsulation, input, output, viewChild } from "@angular/core";
import { MatCalendar, MatCalendarCellClassFunction, MatDatepickerModule } from "@angular/material/datepicker";

const arabicLocale = arEG;
arabicLocale.code = enUS.code;

arabicLocale.localize.ordinalNumber = function ordinalNumber(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

import { IsEnglishDirective } from "../../directives";
import { CustomCalendarHeaderComponent } from "./components";

const MY_MAT_DATE_FNS_FORMATS = {
  parse: MAT_DATE_FNS_FORMATS.parse,
  display: {
    ...MAT_DATE_FNS_FORMATS.display,
    monthLabel: "MMMM",
  },
};

class CustomDateAdapter extends DateFnsAdapter {
  override getDayOfWeekNames(style: "long" | "short" | "narrow") {
    if (this.locale === enUS) return ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

    return ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"];
  }
}

@Component({
  selector: "app-calendar",
  standalone: true,
  imports: [MatDatepickerModule, IsEnglishDirective],
  templateUrl: "./calendar.component.html",
  styleUrl: "./calendar.component.scss",
  encapsulation: ViewEncapsulation.None,
  providers: [
    provideDateFnsAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: enUS },
    { provide: MAT_DATE_FORMATS, useValue: MY_MAT_DATE_FNS_FORMATS },
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
  ],
})
export class CalendarComponent {
  private dateAdapter = inject(DateAdapter<DateFnsAdapter>);

  readonly dateFilter = input.required<(date: Date) => boolean>();
  readonly dateClass = input.required<MatCalendarCellClassFunction<Date>>();

  readonly selected = output<Date | null>({ alias: "onSelect" });

  readonly calendar = viewChild.required(MatCalendar);

  customCalendarHeaderComponent = CustomCalendarHeaderComponent;

  setCalendarLocale(isEnglish: boolean) {
    this.dateAdapter.setLocale(isEnglish ? enUS : arabicLocale);
    this.calendar()?.updateTodaysDate();
  }

  onSelect(date: Date | null) {
    this.selected.emit(date);
  }
}
